import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link as RRLinkUnstyled } from 'react-router-dom';
import color from 'tinycolor2';

export const Nav = styled.nav`
  flex: 1 1 auto;
  min-width: 0;
  overflow: visible;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const P = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  color: ${(props) => props.theme['color.text.body']};
  flex: 1 1 auto;
  min-width: 0;
  overflow: visible;

  /* chevron icon */
  i {
    color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.4).toString()};
    margin: 0 4px;
  }
`;

export const Label = styled.span`
  line-height: 24px;
  color: ${(props) => props.last
    ? props.theme['color.text.body'] : props.theme['color.text.light']};
  font-size: 14px;
`;

export const RRLink = styled(({ last, ...rest }) => <RRLinkUnstyled {...rest} />)`
  line-height: 24px;
  flex: 0 1 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: visible;

  color: ${(props) => props.last ? props.theme['color.text.body'] : props.theme['color.text.light']};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme['color.text.body']};
  }

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    overflow: visible;
    flex: 0 0 auto;
  }
`;

RRLink.propTypes = {
  last: PropTypes.bool,
};
